import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

export const Root = styled(Box)({
    '& .head': {
        marginBottom: '17px',
    },
    '& .wapper': {
        width: '80%',
        backgroundColor: '#fff',
        padding:'24px 40px',
        '& .textWapper': {
            width: '50%',
        }
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#F3F3F3',
        margin: '20px 0',
    },
    '& .textField': {
        width: '100%',
    },
    '& .title': {
        fontSize: '16px',
        fontWeight: 'bold',
    },
});